import { ObjectMapper } from "json-object-mapper";
import { InsightModel } from "./insight.model";

export class InsightComptimeModel extends InsightModel {
  tradeUnions: string[] = [];

  static create(input: any): InsightComptimeModel {
    return ObjectMapper.deserialize<InsightComptimeModel>(InsightComptimeModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}